import { jsonPutCall } from '../../helpers/api/api'

async function validateInputs(refs) {
    for (let ref in refs) {
        if (await refs[ref].validateInput() === false) return false
    }
    return true
}
async function onFormSubmit(state, refs, endPoint) {
    if (await validateInputs(refs) === false) return

    const result = await jsonPutCall(endPoint, state)

    return Promise.resolve(result)
}

export default onFormSubmit
